





























































































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { evalSettingDetailModule } from '@/store/modules/frames/eval-setting-detail.module';
import { DownloadRandomEvalRequests } from '@/models/evalSetting/download-random-eval-request';
import GExamDetailEvalRequestModal from '@/views/GExamDetail/GExamDetailEvalRequestModal.vue';
import GOptionalRadio from '@/components/GOptionalRadio.vue';
import { GPageBase } from '@/mixins';
import { Tag } from '@/models/tag';

@Component({
  name: 'GExamDetailEvalRequestSetting',
  components: { GOptionalRadio, GExamDetailEvalRequestModal },
  computed: {},
  methods: {},
})
export default class GExamDetailEvalRequestSetting extends Mixins(GPageBase) {
  targetDomainType: GEnum.TargetDomainType = GEnum.TargetDomainType.SchoolClass;
  targetDomainTypeName: string = '';
  modalEvalRequest: boolean = false;
  isDownloading: boolean = false;
  selectTagID: number = -1;

  mounted() {
    this.targetDomainType = this.initTargetDomainType;
  }

  countByTagID(tagID: number): number {
    if (evalSettingDetailModule.countByTagID === undefined) {
      return 0;
    }
    if (!evalSettingDetailModule.countByTagID.has(tagID)) {
      return 0;
    }
    return evalSettingDetailModule.countByTagID.get(tagID);
  }

  canSelectPriorityTag(): boolean {
    let overRequiredRespondents = false;
    let underRequiredRespondents = false;
    evalSettingDetailModule.countByPriorityTag.forEach((value, key) => {
      if (value >= this.evalSettingDetail.requiredRespondents + 1) {
        overRequiredRespondents = true;
        return;
      } else if (0 < value && value < this.evalSettingDetail.requiredRespondents + 1) {
        underRequiredRespondents = true;
        return;
      }
    });
    return underRequiredRespondents ? false : overRequiredRespondents;
  }

  get radioTagTooltipText(): string {
    if (!this.evalSettingDetail.canRandomAll) {
      return this.$t('NOTICE_LESS_EXAMINEE').toString();
    } else if (!this.hasExamineeTag) {
      return this.$t('NOTICE_NOT_EXIST_TAG_STUDENT').toString();
    }
  }

  get hasExamineeTag(): boolean {
    return evalSettingDetailModule.examineeTags && this.examineeTags.length > 0;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get examineeTags(): Tag[] {
    return evalSettingDetailModule.examineeTags;
  }

  get initTargetDomainType(): GEnum.TargetDomainType {
    if (this.evalSettingDetail.canRandomSchoolClass) {
      return GEnum.TargetDomainType.SchoolClass;
    } else if (this.evalSettingDetail.canRandomGrade) {
      return GEnum.TargetDomainType.Grade;
    } else if (this.evalSettingDetail.canRandomAll) {
      return GEnum.TargetDomainType.All;
    } else {
      return -1;
    }
  }

  get targetDomainTypeTag(): GEnum.TargetDomainType {
    return GEnum.TargetDomainType.Tag;
  }

  get targetDomainTypeSchoolClass(): GEnum.TargetDomainType {
    return GEnum.TargetDomainType.SchoolClass;
  }

  get targetDomainTypeGrade(): GEnum.TargetDomainType {
    return GEnum.TargetDomainType.Grade;
  }

  get targetDomainTypeAll(): GEnum.TargetDomainType {
    return GEnum.TargetDomainType.All;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get requireGiftRequest(): boolean {
    return evalSettingModule.evalSettingDetail.giftRequired;
  }

  get disableButton(): boolean {
    return !this.requireGiftRequest;
  }

  /**
   * 評価リクエスト のラジオボタン制御
   * GOptionalRadio . condition = !disabled
   * disabled には、非活性にする場合は true を渡すが、
   * GOptionalRadio の condition では、反転させているので、condition = false => 非活性
   */
  get disableEvalRequestTypeRadioType_1(): boolean {
    // 相互評価無しなら非活性なので false を返す
    if (!this.requireGiftRequest) return false;
    return this.evalSettingDetail.canRandomSchoolClass;
  }
  get disableEvalRequestTypeRadioType_2(): boolean {
    // 相互評価無しなら非活性なので false を返す
    if (!this.requireGiftRequest) return false;
    return this.evalSettingDetail.canRandomGrade;
  }
  get disableEvalRequestTypeRadioType_3(): boolean {
    // 相互評価無しなら非活性なので false を返す
    if (!this.requireGiftRequest) return false;
    return this.evalSettingDetail.canRandomAll;
  }
  get disableEvalRequestTypeRadioType_4(): boolean {
    // 相互評価無しなら非活性なので false を返す
    if (!this.requireGiftRequest) return false;
    // 元々あった設定
    return this.evalSettingDetail.canRandomAll && this.hasExamineeTag;
  }

  handleDownloadRandomEvalRequests() {
    this.isRunning = true;

    if (this.targetDomainType === GEnum.TargetDomainType.Tag && this.selectTagID === 0) {
      // 同じタグ内で優先タグを選択していたら
      this.targetDomainType = GEnum.TargetDomainType.PriorityTag;
    }

    if (this.targetDomainType === GEnum.TargetDomainType.SchoolClass) {
      this.targetDomainTypeName = this.$t('IN_SAME_CLASS').toString();
    } else if (this.targetDomainType === GEnum.TargetDomainType.Grade) {
      this.targetDomainTypeName = this.$t('IN_SAME_GRADE').toString();
    } else if (this.targetDomainType === GEnum.TargetDomainType.Tag) {
      this.targetDomainTypeName = this.$t('IN_SAME_TAG').toString();
      for (var i = 0; i < this.examineeTags.length; i++) {
        if (this.examineeTags[i].tagID === this.selectTagID) {
          this.targetDomainTypeName = this.$t('IN_SAME_TAG').toString() +  "（" + this.examineeTags[i].tagContent + "）";
        }
      }
    } else if (this.targetDomainType === GEnum.TargetDomainType.All) {
      this.targetDomainTypeName = this.$t('WHOLE_EXAMINEE').toString();
    } else if (this.targetDomainType === GEnum.TargetDomainType.PriorityTag) {
      this.targetDomainTypeName = this.$t('IN_SAME_TAG_WITH_DESC').toString();
    }

    evalSettingDetailModule
      .downloadRandomEvalRequests({
        evalSettingID: this.evalSettingDetail.evalSettingID,
        targetDomainType: this.targetDomainType,
        targetDomainTypeName: this.targetDomainTypeName,
        title: this.evalSettingDetail.title,
        isPriorityTag: this.selectTagID === 0 ? true : false,
        tagID: this.selectTagID === 0 ? -1 : this.selectTagID,
      } as DownloadRandomEvalRequests)
      .then(() => {
        this.isRunning = false;
      });
  }

  handleRadioChange(v: any) {
    if (v !== GEnum.TargetDomainType.Tag) {
      this.selectTagID = -1;
    }
  }

  handleDownloadRegisteredEvalRequests() {
    this.isDownloading = true;
    evalSettingDetailModule.downloadRegisteredEvalRequests({ evalSettingID: this.evalSettingDetail.evalSettingID, title: this.evalSettingDetail.title } as DownloadRandomEvalRequests).then(() => {
      this.isDownloading = false;
    });
  }
}
